import * as types from "../actions/actionTypes";
import { sort } from "../lib/listMethods";

const CONFIRM_INITIAL_STATE = {
  show: false,
  action: () => {},
  title: "",
  message: ""
};

const initialState = {
  loading: true,
  error: "",
  active_projects: [],
  pending_projects: [],
  archived_projects: [],
  is_fetched: false,

  processing: false,

  deleteProjectLoading: false,
  deletedProjectId: "",

  archiveProjectLoading: false,

  invitationProcessing: false,

  userListLoading: false,
  userListError: "",
  userList: [],

  types: [],
  typesLoading: false,
  typesError: "",

  confirmInfo: CONFIRM_INITIAL_STATE,

  usernameModalStatus: false
};

const handleArchiveProject = (data, id, archive) => {
  let archivedProject = {},
    activeProjects = [],
    archivedProjects = [];
  const tmpArchivedProjects = [...data.archived_projects];
  if (archive) {
    archivedProject = data.active_projects.filter(
      project => project.id === id
    )[0];
    activeProjects = data.active_projects.filter(project => project.id !== id);
    tmpArchivedProjects.push({
      ...archivedProject,
      is_archived: true
    });
    archivedProjects = tmpArchivedProjects;
  } else {
    //unArchive
    archivedProject = tmpArchivedProjects.filter(
      project => project.id === id
    )[0];
    archivedProjects = tmpArchivedProjects.filter(project => project.id !== id);
    const tmpActiveProjects = [...data.active_projects];
    tmpActiveProjects.push({
      ...archivedProject,
      is_archived: false
    });
    activeProjects = tmpActiveProjects;
  }
  return {
    active_projects: sort(activeProjects, true, "name"),
    archived_projects: sort(archivedProjects, true, "name")
  };
};

const handleUpdateProjectsArray = (projects, newData) => {
  let activeProjects = [...projects];
  const matchedProjectIndex = activeProjects.findIndex(
    project => project.id === newData.id
  );
  if (matchedProjectIndex !== -1) {
    activeProjects = [
      ...activeProjects.splice(0, matchedProjectIndex),
      { ...activeProjects[matchedProjectIndex], ...newData },
      ...activeProjects.splice(matchedProjectIndex + 1)
    ];
  } else {
    activeProjects = [...activeProjects, newData];
  }
  return { active_projects: sort(activeProjects, true, "name") };
};

const handleAnswerInvitation = (data, accept, projectId, newProjectUsers) => {
  let pendingProjects = [],
    previousPendingProject = {};
  const tmpActiveProjects = [...data.active_projects];
  previousPendingProject = data.pending_projects.filter(
    project => project.id === projectId
  )[0];
  pendingProjects = data.pending_projects.filter(
    project => project.id !== projectId
  );
  if (accept && previousPendingProject) {
    const finalProjectUsers = [];
    previousPendingProject.project_users.forEach(projectUser => {
      let changed = false;
      newProjectUsers.forEach(newProjectUser => {
        if (projectUser.id === newProjectUser.id) {
          changed = true;
          finalProjectUsers.push(newProjectUser);
        }
      });
      if (!changed) {
        finalProjectUsers.push(projectUser);
      }
    });
    previousPendingProject = {
      ...previousPendingProject,
      project_users: finalProjectUsers
    };
    tmpActiveProjects.push(previousPendingProject);
  }

  return {
    active_projects: sort(tmpActiveProjects, true, "name"),
    pending_projects: sort(pendingProjects, true, "name")
  };
};

const Project = (state = initialState, action) => {
  switch (action.type) {
    case types.PROJECT_LIST_REQUEST:
      return { ...state, loading: true, error: "", is_fetched: false };
    case types.PROJECT_LIST_SUCCESS:
      return {
        ...state,
        ...action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.PROJECT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case types.PROJECT_ACCEPT_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_ACCEPT_SUCCESS:
      return { ...state, loading: false };
    case types.PROJECT_ACCEPT_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_REJECT_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_REJECT_SUCCESS:
      return { ...state, loading: false };
    case types.PROJECT_REJECT_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_STORE_REQUEST:
      return { ...state, processing: true };
    case types.PROJECT_STORE_SUCCESS:
      return {
        ...state,
        ...handleUpdateProjectsArray(state.active_projects, action.payLoad),
        processing: false
      };
    case types.PROJECT_STORE_FAILURE:
      return { ...state, processing: false };

    case types.PROJECT_UPDATE_REQUEST:
      return { ...state, processing: true };
    case types.PROJECT_UPDATE_SUCCESS:
      return {
        ...state,
        ...handleUpdateProjectsArray(state.active_projects, action.payLoad),
        processing: false
      };
    case types.PROJECT_UPDATE_FAILURE:
      return { ...state, processing: false };

    case types.PROJECT_DELETE_REQUEST:
      return { ...state, deleteProjectLoading: true };
    case types.PROJECT_DELETE_SUCCESS:
      const id = action.deletedProjectId;
      const newArchivedProjectList = state.archived_projects.filter(
        project => parseInt(project.id) !== parseInt(id)
      );
      return {
        ...state,
        archived_projects: newArchivedProjectList,
        deleteProjectLoading: false,
        confirmInfo: CONFIRM_INITIAL_STATE
      };
    case types.PROJECT_DELETE_FAILURE:
      return {
        ...state,
        deleteProjectLoading: false,
        confirmInfo: CONFIRM_INITIAL_STATE
      };

    case types.PROJECT_ARCHIVE_REQUEST:
      return {
        ...state,
        archiveProjectLoading: true
      };
    case types.PROJECT_ARCHIVE_SUCCESS:
      return {
        ...state,
        archiveProjectLoading: false,
        ...handleArchiveProject(state, action.id, action.data.archive_state),
        confirmInfo: CONFIRM_INITIAL_STATE
      };
    case types.PROJECT_ARCHIVE_FAILURE:
      return {
        ...state,
        archiveProjectLoading: false,
        confirmInfo: CONFIRM_INITIAL_STATE
      };

    case types.PROJECT_ANSWER_INVITATION_REQUEST:
      return {
        ...state,
        invitationProcessing: true
      };
    case types.PROJECT_ANSWER_INVITATION_SUCCESS:
      return {
        ...state,
        ...handleAnswerInvitation(
          state,
          action.ansIsAccept,
          action.projectId,
          action.data
        ),
        invitationProcessing: false
      };
    case types.PROJECT_ANSWER_INVITATION_FAILURE:
      return { ...state, invitationProcessing: false };

    case types.PROJECT_USERS_LIST_REQUEST:
      return { ...state, userListLoading: true, userListError: "" };
    case types.PROJECT_USERS_LIST_SUCCESS:
      return { ...state, userListLoading: false, userList: action.payLoad };
    case types.PROJECT_USERS_LIST_FAILURE:
      return { ...state, userListLoading: false, userListError: action.error };

    case types.PROJECT_TYPES_REQUEST:
      return { ...state, typesLoading: true, typesError: "" };
    case types.PROJECT_TYPES_SUCCESS:
      return { ...state, typesLoading: false, types: action.payLoad };
    case types.PROJECT_TYPES_FAILURE:
      return { ...state, typesLoading: false, typesError: action.error };

    case types.PROJECT_CLEAR_LIST:
      return {
        ...state,
        active_projects: [],
        pending_projects: [],
        archived_projects: [],
        is_fetched: false
      };

    case types.SET_PROJECT_DELETE_ARCHIVE_CONFIRM_INFO:
      return {
        ...state,
        confirmInfo: action.info ? action.info : CONFIRM_INITIAL_STATE
      };

    case types.SHOW_USERNAME_MODAL:
      return {
        ...state,
        usernameModalStatus: true
      };
    case types.HIDE_USERNAME_MODAL:
      return {
        ...state,
        usernameModalStatus: false
      };
    default:
      return state;
  }
};

export default Project;
